import type { ReactNode } from "react";
import { Box, styled } from "~/common/mui";
import { PageTitle } from "~/common/components/PageTitle/v2/PageTitle";
import { resolveResourceURl } from "~/utils/url/urlResolver";

export interface DesktopOnlyMessageProps {
  title?: ReactNode;
  children: ReactNode;
}

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  gap: theme.spacing(6),
  "& .title, & .text": { margin: 0 },
  "& .image": {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    aspectRatio: "248 / 190",
  },
}));

export const DesktopOnlyMessage = ({ title, children }: DesktopOnlyMessageProps) => (
  <Root>
    {title && <PageTitle className="title">{title}</PageTitle>}
    <img className="image" src={resolveResourceURl("/images/pcchan.svg")} alt="" />
    <p className="text">{children}</p>
  </Root>
);
